import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import Home from './pages/Home';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Profile from './pages/Profile';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import BookService from './pages/BookService';
import ApplyEngineer from './pages/ApplyEngineer';
import AdminEngineerRequests from './pages/AdminEngineerRequests';
import EngineerDashboard from './pages/EngineerDashboard';
import CustomerDashboard from './pages/CustomerDashboard';
import About from './pages/About';
import Contact from './pages/Contact';
import Services from './pages/Services';
import ForgotPassword from './pages/ForgotPassword';
import NotFound from './pages/NotFound';
import WhatsAppWidget from './components/WhatsAppWidget';

// Ensures every route change starts scrolled to top, instead of relying
// on individual Link onClick handlers scattered across components.
function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'instant' : 'auto' });
  }, [pathname]);
  return null;
}

function AppContent() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />
      <Navbar isHome={isHome} />

      <main className="flex-1">
        <Routes>
          {/* Public pages */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/book-service" element={<BookService />} />
          <Route path="/apply-engineer" element={<ApplyEngineer />} />
          <Route path="/services" element={<Services />} />

          {/* Authenticated pages */}
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />
          <Route
            path="/engineer/dashboard"
            element={
              <PrivateRoute>
                <EngineerDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/customer/dashboard"
            element={
              <PrivateRoute>
                <CustomerDashboard />
              </PrivateRoute>
            }
          />

          {/* Admin pages */}
          <Route
            path="/admin/engineer-requests"
            element={
              <AdminRoute>
                <AdminEngineerRequests />
              </AdminRoute>
            }
          />

          {/* Catch-all 404 Route */}
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>

      <Footer />
      <WhatsAppWidget />
      <ToastContainer position="bottom-right" />
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </AuthProvider>
  );
}